type Ga4Params = Record<string, string | number | boolean | null | undefined>;

type DataLayerWindow = Window & {
	dataLayer?: Array<Record<string, unknown>>;
};

function compactParams(params: Ga4Params) {
	return Object.fromEntries(
		Object.entries(params).filter(([, value]) => value !== undefined),
	);
}

export function trackGa4Event(eventName: string, params: Ga4Params = {}) {
	if (typeof window === "undefined") return;
	const dataLayerWindow = window as DataLayerWindow;
	dataLayerWindow.dataLayer = dataLayerWindow.dataLayer || [];
	dataLayerWindow.dataLayer.push({
		event: eventName,
		...compactParams(params),
	});
}

export function trackGa4EventOnce(
	storageKey: string,
	eventName: string,
	params: Ga4Params = {},
) {
	if (typeof window === "undefined") return;
	const key = `ar:ga4:${storageKey}`;
	if (window.localStorage.getItem(key) === "1") return;
	window.localStorage.setItem(key, "1");
	trackGa4Event(eventName, params);
}
